import { LearningContentPage } from "@/features/learning-content/pages/LearningContent";

const LearningContent = () => {
  return <LearningContentPage />;
};

export default LearningContent;
